import {cloneDeep as _cloneDeep} from 'lodash';
import CourseModel from "@/models/CourseModel"

const CoursesModule = {
    namespaced: true,
    state: () => ({
        // Список курсів для таблиці
        courses: [],
        // Поточний курс для форм
        course: _cloneDeep(CourseModel),
        // Загальна кількість курсів для пагінації
        coursesCount: 0,
        // Всі курси для вибору (без пагінації)
        allCourses: [],
        // Параметри фільтрації
        filters: {
            search: null,
            sort_by: 'title',
            sort_dir: 'desc',
            per_page: 30,
            page: 1
        }
    }),
    
    getters: {
        getCourses(state) {
            return state.courses
        },
        getCourse(state) {
            return state.course
        },
        getCoursesCount(state) {
            return state.coursesCount
        },
        getAllCourses(state) {
            return state.allCourses
        },
        getFilters(state) {
            return state.filters
        }
    },
    
    mutations: {
        setCourses(state, payload) {
            state.courses = payload
        },
        setCourse(state, payload) {
            state.course = payload
        },
        setCoursesCount(state, payload) {
            state.coursesCount = payload
        },
        setAllCourses(state, payload) {
            state.allCourses = payload
        },
        setFilters(state, payload) {
            state.filters = { ...state.filters, ...payload }
        },
        resetFilters(state) {
            state.filters = {
                ...state.filters,
                search: null,
                sort_by: 'title',
                sort_dir: 'desc',
                page: 1
            }
        }
    },
    
    actions: {
        setCourses(context, payload) {
            context.commit('setCourses', payload);
        },
        setCourse(context, payload) {
            context.commit('setCourse', payload);
        },
        setCoursesCount(context, payload) {
            context.commit('setCoursesCount', payload);
        },
        setAllCourses(context, payload) {
            context.commit('setAllCourses', payload);
        },
        setFilters(context, payload) {
            context.commit('setFilters', payload);
        },
        resetFilters(context) {
            context.commit('resetFilters');
        }
    }
}

export default CoursesModule;


